import blocks from 'views/application/entryBlocks/blocks';

export default {
	...blocks,
};
